import React, { useState } from "react";
import color from "~styles/color";
import { css } from "@emotion/react";
import { Tooltip } from "antd";
import { CopyFilled } from "@ant-design/icons";
import { Code } from "~components/documentation";

export function BibTex(props: { bibtexText: string }) {
  const [copyText, setCopyText] = useState("Copy to Clipboard");
  return (
    <div
      css={css`
        border: 1px solid #aec8d288;
        background-color: ${color.dark.geekblue1};
        overflow: hidden;
        border-radius: 5px;
        z-index: 99 !important;
        position: relative;
        margin-top: 5px;
      `}
    >
      <div
        css={css`
          color: ${color.gray5};
          z-index: 99 !important;
          font-weight: 600;
          color: ${color.gray12};
          background-color: #252b41;
          color: #aec8d2;
          padding: 5px 15px;
          position: relative;
          text-align: left;
        `}
      >
        BibTeX
        <Tooltip
          placement="topRight"
          title={<span>{copyText}</span>}
          onVisibleChange={(visible: boolean) => {
            setTimeout(() => {
              if (!visible && copyText !== "Copy to Clipboard") {
                setCopyText("Copy to Clipboard");
              }
            }, 300);
          }}
        >
          <div
            css={css`
              position: absolute;
              right: 0px;
              top: 0px;
              bottom: 0px;
              font-weight: 600;
              color: #aec8d2;
              border-left: 1px solid #aec8d244;
              background-color: #aec8d211;
              line-height: 30px;
              padding-left: 15px;
              user-select: none;
              padding-right: 15px;
              &:hover {
                cursor: pointer;
              }
            `}
            onClick={() => {
              navigator.clipboard.writeText(props.bibtexText);
              setCopyText("Copied");
            }}
          >
            <CopyFilled /> Copy
          </div>
        </Tooltip>
      </div>
      <div
        css={css`
          position: relative;
          background-color: ${color.dark.geekblue1};
          div {
            &::-webkit-scrollbar {
              display: none !important;
              width: 0 !important;
              background: transparent !important;
            }
            &::-webkit-scrollbar-thumb {
              background: #ff0000;
              border-radius: 15px;
            }
            -ms-overflow-style: none !important;
            scrollbar-width: none !important;
          }

          > div {
            background-color: ${color.dark.geekblue1};
            padding: 0px !important;
            pre {
              padding-top: 0px !important;
              margin: 0px !important;
              padding-left: 15px !important;
              padding-right: 15px !important;
              padding-bottom: 15px !important;
            }
            border-radius: 0px;
          }
        `}
      >
        <Code>{props.bibtexText}</Code>
      </div>
    </div>
  );
}
